export const dictRouting = [
  {
    path: "/data-dict/dict/list/person",
    name: "data-dict-list-person",
    meta: { title: "人事类" },
    component: () =>
      import(/* webpackChunkName: "basic-dict" */ "@/views/data-dict/dict/list/index.vue"),
  },
  {
    path: "/data-dict/dict/list/admin",
    name: "data-dict-list-admin",
    meta: { title: "行政类" },
    component: () =>
      import(/* webpackChunkName: "basic-dict" */ "@/views/data-dict/dict/list/index.vue"),
  },
  {
    path: "/data-dict/dict/list/project",
    name: "data-dict-list-project",
    meta: { title: "项目类" },
    component: () =>
      import(/* webpackChunkName: "basic-dict" */ "@/views/data-dict/dict/list/index.vue"),
  },
];
